import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';
import ServicePointsFilter from '../../general/readableids/servicepointsfilter';
import ExecutionStatus from '../../../enums/system/executionstatus';

export default Vue.component('routeassignment-modal', {
    template:`
    <div class="modal-content">
        <form class="js-manage-route-assignment" @submit.prevent="assignRoute">
            <div class="block block-rounded block-transparent mb-0">
                <div class="block-header bg-gray-lighter">
                    <h3 class="block-title">{{ resources.title }}</h3>
                </div>
                <div class="block-content">
                    <servicepointsfilter v-model="requester.value" 
                        :label="resources.requester" :prefix="requester.prefix" 
                        :text.sync="requester.text" :description.sync="requester.description" :readonly="true" />
                    <servicepointsfilter v-model="transporter.value" 
                        :label="resources.transporter" :prefix="transporter.prefix" 
                        :text.sync="transporter.text" :description.sync="transporter.description" />
                    <servicepointsfilter v-model="receiver.value" 
                        :label="resources.receiver" :prefix="receiver.prefix" 
                        :text.sync="receiver.text" :description.sync="receiver.description" />
                    <div v-show="routeAssignmentMessages.length > 0" class="form-group">
                        <div :class="validationClass">
                            <h6 class="alert-heading my-2">{{resources.validationTitle}}</h6>
                            <ul class="list-unstyled mb-0 font-size-sm">
                                <li v-for="message in routeAssignmentMessages" style="word-break: break-all;">
                                    {{ message }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="block-content block-content-full text-right border-top">
                    <button class="btn btn-sm btn-dual mr-1" type="button" @click="$emit('close')">{{ resources.close }}</button>
                    <button class="btn btn-sm btn-primary" type="submit">{{ resources.changeRoute }}</button>
                </div>
            </div>
        </form>
    </div>
    `,
    components:{
        'servicepointsfilter': ServicePointsFilter
    },
    data(){
        return {
            routeAssignmentStatus: ExecutionStatus.Unknown,
            routeAssignmentMessages: []
        }
    },
    props:{
        orderId: String,
        name: String,
        requester: Object,
        transporter: Object,
        receiver: Object,
        resources: Object,
        axe: Function
    },
    computed:{
        validationClass(){
            return this.routeAssignmentStatus === ExecutionStatus.Success ? 'alert alert-success' : 'alert alert-danger';
        }
    },
    methods:{
        assignRoute(event){
            // todo : validate form
            var requestParameters = {
                orderId: this.orderId,
                transporterId: this.transporter.value,
                receiverId: this.receiver.value
            };

            this.axe.get('/changerouteassignment', { 
                params: { parameters: requestParameters }
            }).then((response) => { 
                if(response.data.status === ExecutionStatus.Success){
                    window.location.href = response.data.redirectUrl;
                } else {
                    this.routeAssignmentStatus = response.data.status;
                    this.routeAssignmentMessages = response.data.messages;
                }
            }).catch((thrown) => {
                console.log('app error', thrown.message);
            });
        }
    }
});